import React from 'react';
import ErrorMessage from '../components/ErrorMessage';

export function Page404() {
	return <ErrorMessage title="We are sorry, Page not found!." list={['Please check that the connection is correct.']} code="404" />;
}
